<template>
  <VSection large label="transactions.bundle_information_headline">
    <VBundlePurchase :transaction-details="transactionDetails"></VBundlePurchase>
    <VBundleUsage :transaction-details="transactionDetails"></VBundleUsage>
  </VSection>
</template>

<script>
import VSection from '@/components/Section';
import VBundlePurchase from './Purchase';
import VBundleUsage from './Usage';

export default {
  name: 'PaymentTransactionsDetailsBundle',

  components: {
    VSection,
    VBundlePurchase,
    VBundleUsage,
  },

  props: {
    transactionDetails: {
      type: Object,
      required: false,
      default: null,
    },
  },
};
</script>
